import { JSX, ReactNode } from 'react';

// components
import { AtClickable } from '../at-clickable';
import { IAtLinkProps } from './at-link.types';
import { EClickableSize } from '../at-clickable/at-clickable.types';

export const AtLink = ({
  children,
  className,
  iconPosition,
  href,
  label,
  target,
  variant,
  size = EClickableSize.LG,
  outline,
  ariaLabel,
  interactLocation,
  type,
}: IAtLinkProps): JSX.Element => {
  return (
    <AtClickable
      className={className}
      href={href}
      iconPosition={iconPosition}
      label={label}
      target={target}
      variant={variant}
      size={size}
      outline={outline}
      ariaLabel={ariaLabel}
      interactLocation={interactLocation || 'at-link'}
      type={type}
    >
      {children}
    </AtClickable>
  );
};
